// react =>
import React, { RefObject } from "react";

// utils =>
import { ValidateRequiredFields } from "../../utils/FieldValidation";

export const SaveToSession = (
    nameInputRef: RefObject<HTMLInputElement | null>,
    lastNameInputRef: RefObject<HTMLInputElement | null>,
    phoneNumberInputRef: RefObject<HTMLInputElement | null>,
    genderSelectBoxRef : RefObject<HTMLSelectElement | null>,
    emailAddressInputRef: RefObject<HTMLInputElement | null>,
) => {
    const formData = {
        name: nameInputRef.current?.value || "",
        lastName: lastNameInputRef.current?.value || "",
        phoneNumber: phoneNumberInputRef.current?.value || "",
        email: emailAddressInputRef.current?.value || "",
        gender: genderSelectBoxRef.current?.value || "NOT",
    };
    sessionStorage.setItem("signInForm", JSON.stringify(formData));
};

export const HandleSignInSubmit = (
    refs: {
        name: React.RefObject<HTMLInputElement | null>;
        lastName: React.RefObject<HTMLInputElement | null>;
        phoneNumber: React.RefObject<HTMLInputElement | null>;
        emailAddress: React.RefObject<HTMLInputElement | null>;
        gender: React.RefObject<HTMLSelectElement | null>;
    },
    rulesAccepted: boolean,
    navigate: (path: string, options?: any) => void,
    showMessage: (type: "error" | "success", text: string) => void,
) => {
    if (!ValidateRequiredFields(
        (msg) => showMessage("error", msg),
        refs.name,
        refs.lastName,
        refs.phoneNumber,
    )) return;

    if (!rulesAccepted) {
        showMessage("error", "شما شرایط و مقررات را قبول نکرده اید!");
        return;
    }

    navigate("/code-receive", {
        state: {
            name: refs.name.current?.value,
            lastName: refs.lastName.current?.value,
            phoneNumber: refs.phoneNumber.current?.value,
            emailAddress: refs.emailAddress.current?.value,
            gender: refs.gender.current?.value,
            actionType: "sign-in",
        }
    });
};
